import React from "react";
import './FileInput.css'

const FileInput = ({
  disabled = false,
  inputBg = "",
  inputClass,
  onChangeInput,
  width = "w-full",
  value = "",
  mainClass,
  isMultiple = false,
  hiddenClass = false,
  ref
}) => {
  
  return (
    <>
    <div className={'custom-file-type-admin'}>
      <input
        type={"file"}
        className={`file-body`}
        // style={{ height: "58px", marginTop: "35px", fontSize: "20px" }}
        onChange={(e) => onChangeInput(e.target.files)}
        disabled={disabled}
        // style={{
        //   height: '41px',
        //   background: 'transparent',
        //   color: 'gray',
        //   border: '1px solid lightgray',
        //   borderRadius: '4px',
        //   opacity: !disabled ? 1 : 0.25,
        // }}
        ref={ref}
        value={value}
        multiple={isMultiple}
      ></input>
    </div>
    {/* <div className="text-slate-500">
        {value.length > 0 ? (
          <div>
            <p>Selected Files:</p>
            <ul>
              {value.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          </div>
        ) : (
          <p>No files selected</p>
        )}
      </div> */}
   </> 
  );
};

export default FileInput;
